import { createStore, compose } from 'redux';
import reducers from './reducers';

const middleware = [];
if(window.__REDUX_DEVTOOLS_EXTENSION__) middleware.push(window.__REDUX_DEVTOOLS_EXTENSION__());

const store = createStore(reducers, compose(...middleware));

export default store;